import React, { useState, useEffect } from 'react'
import { ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { SamplingRequests } from 'submodules/nerit-aquatec-sdk/services/samplings/SamplingRequests'
import { SamplingResponseDTO } from 'submodules/nerit-aquatec-sdk/services/samplings/dtos/responses/SamplingResponseDTO'
import { SamplingSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/samplings/dtos/requests/SamplingSearchRequestDTO'
import { LocationResponseDTO } from 'submodules/nerit-aquatec-sdk/services/location/dtos/responses/LocationResponseDTO'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'

interface ICPProps {
    visible: boolean
    onCancel: () => void
    location: LocationResponseDTO
}

export function ModalLocationCampaignsCP(props: ICPProps): JSX.Element {

    const [reloadData, setReloadData] = useState<number>(1)

    const searchFilters: SamplingSearchRequestDTO = {
        locationCode: props.location.code
    }

    // Recarrega a tabela sempre que o modal for aberto
    useEffect(() => {
        if (props.visible) {
            setReloadData(TableUtils.getReloadNumber())
        }
    }, [props.visible])

    return (
        <ModalCP
            visible={props.visible}
            onCancel={props.onCancel}
            title={`Campanhas do Ponto ${props.location.name}`}
            width={1000}
            noFooter={true}
        >
            <TableFromApiCP<SamplingResponseDTO>
                apiConfig={{
                    hasPagination: true,
                    pageSize: 20,
                    requestConfigTP: () => SamplingRequests.getList(searchFilters)
                }}
                appearance={{
                    showReloadButton: true,
                    wrappedOnCard: false,
                    showTotalOnHeader: true
                }}
                shouldLoadData={reloadData}
                columns={[
                    {
                        title: '#',
                        render: (text, record) => record.code
                    },
                    {
                        title: 'Nome',
                        render: (text, record) => <TextCP text={record.name} size={'small'} copyable={true}/>
                    },
                    {
                        title: 'Data Início',
                        render: (text, record) => record.beginDate
                    },
                    {
                        title: 'Data Fim',
                        render: (text, record) => record.endDate
                    }
                ]}
            />
        </ModalCP>
    )
}
